var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 11.75H5V13.25H10.25V11.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H5V9.5H14V8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.25H5V5.75H14V4.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64 21.5H2.75C1.92 21.5 1.25 20.83 1.25 20V2C1.25 1.17 1.92 0.5 2.75 0.5H16.25C17.08 0.5 17.75 1.17 17.75 2V6.59H16.25V2H2.75V20H6.64V21.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.65 10.82L20.18 8.35C19.96 8.13 19.65 8 19.34 8C19.03 8 18.72 8.12 18.5 8.35L8 18.85V23H12.15L22.65 12.5C22.87 12.28 23 11.97 23 11.66C23 11.35 22.88 11.04 22.65 10.82ZM11.53 21.5H9.5V19.47L16.58 12.39L18.61 14.42L11.53 21.5ZM19.67 13.36L17.64 11.33L19.34 9.63L21.37 11.66L19.67 13.36Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentPencil);
export default __webpack_public_path__ + "static/media/ic-document-pencil.25e395394bb0536b3c4339b4615d8729.svg";
export { ForwardRef as ReactComponent };